module.exports = __webpack_public_path__ + "static/media/guide.46d61dbf.pdf";